import * as ReactDOM from 'react-dom/client';

import { Provider } from 'react-redux';

import App from './app/app';
import { store } from './app/store';
import './styles.css';
import LoadingOverlay from './app/ui-components/Loader';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <Provider store={store}>
    <LoadingOverlay />
    <App />
  </Provider>
);
